<template> 
   <div class="container-reclef">
 <TopoSlot></TopoSlot>

     <p style="color: #000;font-size:25px;font-weight:700;margin: 65px 50px 25px 50px;">Importar documentos de Saída a serem analisados</p>  
      <div style="width: 100%;max-width: 900px; margin: 0 auto;">  
          <label for="assetsFieldHandle" style="display: flex; align-items: center; justify-content: center; background: rgb(175, 52, 55); cursor: pointer; width: 100%; height: 40px; border-radius: 2px; margin: 60px 0px 25px;"><p style="font-size: 14px; margin: 0px; color: rgb(255, 255, 255);font-weight:600;"><i class=" fas fa-file-upload" style="margin: 0px 20px; font-size: 18px;color: #fff;"></i> Clique aqui para adicionar arquivos</p></label>
       <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle" style="display: none;"       
      class="w-px h-px opacity-0 overflow-hidden absolute" @change="onChange" ref="file" accept=".zip,.xml" />
       <div class="flex w-full h-screen items-center justify-center text-center">
        <div class="p-12 bg-gray-100 border border-gray-300" @dragover="dragover" @dragleave="dragleave" @drop="drop" style="    flex-direction: column;display: flex;border-radius: 8px;align-items:center;justify-content: center;">
            <label for="assetsFieldHandle" class="block cursor-pointer" style=" width: 100%;height: 100%;">
                <div style="color: #7e7e7e;cursor: pointer;font-size: 14px;font-weight: 400;width: 100%;display: flex;height: 100%;align-items: center; justify-content: center;" >
                    <span style="padding: 44px;" v-show="spiner && exibir">Se preferir, arraste aqui os seus arquivos .ZIP e .XML  </span>    <span style="padding: 44px;"  v-show="!spiner"><b-spinner label="Spinning"></b-spinner></span>            
                </div>
            </label>
            <ul class="mt-4" v-if="this.filelist.length" v-cloak v-show="spiner">
            <li class="text-sm p-1" v-for="file in filelist" :key="file">
                {{file.name }}<button class="ml-2" type="button" @click="remove(filelist.indexOf(file))" title="Remove file">remove</button>
            </li>
            </ul>
        </div>
        </div>
        <div class="escolha-calculo" style="margin-top: 50px; margin-bottom: 50px; text-align: center;">
            <p style="color: #000; font-weight: 600; margin-bottom: 15px;">Qual ICMS será excluído da base de cálculo?</p>
            <label id="labelIcmsNormal" style="margin-right: 20px; cursor: pointer; border-radius: 5px; padding: 10px 15px; color: #333;">
                <input type="radio" v-model="tipoIcms" value="NORMAL" style="margin-right: 5px; accent-color: #af3437;">
                ICMS Normal
            </label>
            <label style="cursor: pointer; border-radius: 5px; padding: 10px 15px; color: #333;">
                <input type="radio" v-model="tipoIcms" value="ST" style="margin-right: 5px; accent-color: #af3437;">
                ICMS-ST
            </label>
            <label style="cursor: pointer; border-radius: 5px; padding: 10px 15px; color: #333;">
                <input type="radio" v-model="tipoIcms" value="difal" style="margin-right: 5px; accent-color: #af3437;">
                DIFAL ICMS Interestadual - Não Contribuinte
            </label>
            <div v-if="tipoIcms === 'ST'" style="margin-top: 20px; padding: 10px; background-color: #f0f0f0; border-radius: 5px;">
            <label style="cursor: pointer; font-weight: normal; font-size: 14px; color:#333">
                <input type="checkbox" v-model="usarCalculoAgregado" style="margin-right: 8px; vertical-align: middle; accent-color: #af3437;">
                Multiplicar valor da ST retido anteriormente pela quantidade de notas
            </label>
            </div>
        </div>
        <div class="nota"><p><span style="color: rgb(54, 121, 149);">NOTA:</span> A Lefisc não se responsabiliza pelas informações constantes nos documentos fiscais eletrônicos utilizados na importação do RECLEF.</p></div>
        <div class="nota"><p><span style="color: rgb(54, 121, 149);">NOTA:</span> O RECLEF somente realizará o cálculo para os documentos emitidos a partir de 16.03.2017, conforme determinado pelo STF através do TEMA 69.</p></div>
        </div>

        <div style="display: flex; align-items: center; justify-content: center;flex-direction: column;margin-top: 30px;">
            <button class="continue-button" @click="finalizar">Finalizar importação</button>
        </div>
        <div>
            <button @click="voltarPagina()" style="width: 100%; max-width: 130px;  height: 40px;background: #af3437; color: #fff; font-size: 15px; font-weight: 700; margin-bottom: 20px; border-radius: 5px;">Voltar</button>
        </div>    
</div>
     
</template>
    
<script>

import config from '../services/config'
export default {
    data(){
        return{
            filelist:[],
            spiner:true,
            exibir:true,
            tipoIcms: 'NORMAL',
            usarCalculoAgregado: false
        }
    },
    methods:{   

        voltarPagina (){
            this.$router.push({ name: 'revisar' })
        },
   
        async finalizar(){
            const mockResponse = {
    "cnpj": "XX.XXX.XXX/0001-XX",
    "tipoDocumento": 1,
    "anos": [
        {
            "ano": 2025,
            "meses": [
                {
                    "mes": 9,
                    "documentos": [
                        {
                            "produto": "PRODUTO DE TESTE 1",
                            "ncm": "85364100",
                            "data": "29/09/2025",
                            "chaveAcesso": "00000000000000000000000000000000000000000000",
                            "aliquotaOriginal": { "pis": "R$ 10,00", "cofins": "R$ 40,00" },
                            "aliquotaReajustada": { "pis": "R$ 10,10", "cofins": "R$ 40,40" }
                        }
                    ],
                    "totalOriginal": { "pis": "R$ 10,00", "cofins": "R$ 40,00" },
                    "totalReajustado": { "pis": "R$ 10,10", "cofins": "R$ 40,40" }
                }
            ],
            "totalOriginal": { "pis": "R$ 10,00", "cofins": "R$ 40,00" },
            "totalReajustado": { "pis": "R$ 10,10", "cofins": "R$ 40,40" }
        }
    ],
    "totalGeralOriginal": "R$ 50,00",
    "totalGeralReajustado": "R$ 50,50",
    "erros": { "contador": 0, "lstErros": [] },
    "totalICMSSTRetMultiplicado": "R$ 999,99"
};
            this.spiner = false
            let formXml = new FormData()
            console.log(this.$store.state.idCliente)
            let i = 0;
            this.filelist.forEach(e=>{
                formXml.append(`file[${i}]`,e)
                i++
            })           
            let obj = {
                "tipoDocumento":this.$store.state.tipoDocumento,
                "cnpj":this.$store.state.cnpj,
            }
            if(obj.tipoDocumento == 2){
                obj.regimeTributario =this.$store.state.regimeTributario
            }            
            formXml.append("entrada",JSON.stringify(obj))
            let result = await config.enviarNotas(this.$store.state.idCliente,formXml, this.tipoIcms);   
            
            
            //* Mock da API para testar o ST agregado:

            const usarMock = false; // deixar true para usar o mock e deixar false para usar a API de verdade

            if (usarMock) {
        console.warn("MODO DE TESTE ATIVADO: Usando resposta de mock");
        
        this.$store.state.resultado = mockResponse; 
        
        this.$store.state.mostrarCalculoAgregado = true; 
        
        this.$router.push({ name: 'resultado' });

    } else if (result.status <= 205) {
        this.$store.state.resultado = result.data;
        this.$store.state.mostrarCalculoAgregado = this.usarCalculoAgregado;
        this.$router.push({ name: 'resultado' });
    }
            if(result.status <=205){
                this.$store.state.resultado = result.data
                this.$store.state.mostrarCalculoAgregado = this.usarCalculoAgregado;

                this.$store.state.tipoDeAnalise = this.tipoIcms;
                this.$router.push({name:'resultado'})
            }  
            this.spiner = true
        },
    onChange() {
        this.exibir = false
      this.filelist = [...this.$refs.file.files];
    },
    remove(i) {
      this.filelist.splice(i, 1);
      if(this.filelist.length ==0){
          this.exibir = true
      }
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('bg-green-300')) {
        event.currentTarget.classList.remove('bg-gray-100');
        event.currentTarget.classList.add('bg-green-300');
      }
    },
    dragleave(event) { 
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); 
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    }
  
    }
    

}
</script>

<style>
li.text-sm.p-1 {
    font-size: 13px;
}
label {
    color: #7e7e7e;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
}
li{
    color: #3e3e3e;
}
li  button{
    color: #1696e7;
    outline: medium none;
    background: #fff;
}
.nota {
    width: 100%;
    background: #fff3cd;
    border: 1px solid #ffeeba;
    margin: 15px 0;  
}
.nota p {
    margin: 0!important;
    font-size: 15px!important;
    color: #212529!important;
    padding: 10px;
    font-weight: 700!important;
    text-align: justify;
}
.blocos{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.radio-component>input:active+label>.input-box, .radio-component>input:checked+label>.input-box, .radio-component>input:focus+label>.input-box {
    background: #af3437!important;
    background-image: none!important;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
}
.large-bar-radio {
    margin: 0 0 0 20px;
}
.radio-component>input {
    opacity: 0;
    position: absolute;
}
.radio-component>input:checked+label>.input-box>.input-box-circle {
    opacity: 1;
    margin: 22%;
    width: 56%;
    height: 56%;
}
label{
    margin-bottom: 0px;
}
.radio-component>input+label>.input-box>.input-box-circle {
    display: block;
    margin: 50%;
    width: 0;
    height: 0%;
    background: #fff;
    border-radius: 50%;
    opacity: 0;
    transition: width .15s ease-in,height .15s ease-in,margin .15s ease-in;
}
.radio-component>input+label>.input-box {
    display: inline-block;
    border: 1px solid #000;
    border-radius: 50%;
    margin: 0;
    padding: 0;
    width: 1em;
    height: 1em;
    background: #fff;
    overflow: hidden;
    vertical-align: -5%;
    user-select: none;
}

.radio-component>input+label>.input-box {
    border-color: #af3437!important;
    background: #fff!important;
}
.large-bar p{
    font-size: 14px;
    margin: 0px 0px 0px 20px; 
    font-weight: 700; 
    color: rgb(56, 56, 56); 
    line-height: 15px;
}
.blocos{
    display: flex;   
    justify-content: center;
}
.large-bar {    
    display: flex;
    align-items: center;  
    justify-content: flex-start;
    min-height: 70px!important;
    max-height: 300px!important;
    height: 100px!important;
    background: #eee;
    max-width: 600px;
    width: 100%;
    border-radius: 5px;   
    transition: all .2s;
    border-left: 10px solid #af3437;
}
#cnpj-reclef{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
}
#cnpj-reclef p{
    text-align: center; 
    font-size: 18px; 
    color: rgb(0, 0, 0); 
    font-weight: bold;
    margin-bottom: 0;
}
#cnpj-reclef input{
    border-radius: 10px;
    min-height: 35px;
    border: 1px solid #707070;
    max-width: 380px;
    width: 100%;
    padding-left: 10px;
    font-size: 13px;
}
#cnpj-reclef button{
    width: 100%;
    max-width: 130px;
    height: 40px;
    background: #af3437;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}
.continue-button{
    margin-top: 40px;
    width: 200px;
    height: 50px;
    background: #af3437;
    color: #fff;
    font-size: 15px;
    font-style: italic;
    border-radius: 5px;
    margin-bottom:50px;
}
</style>